import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out after 2 seconds
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 2000);

    // Trigger onComplete after fade out animation (3.2 seconds total)
    const completeTimer = setTimeout(() => {
      onComplete();
    }, 3200);

    return () => {
      clearTimeout(timer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 1.2s ease-out',
      }}
    >
      <img
        src="ConnectionHealthLogoTransparent.png"
        alt="Connection Health Care Logo"
        style={{
          width: '40%', // Explicitly set width to ensure larger size
          height: 'auto', // Maintain aspect ratio
          objectFit: 'contain',
          margin: 'auto', // Ensures the image remains centered
        }}
      />
    </div>
  );
};

export default SplashScreen;